import React from 'react';
import './disclaimer.css';

export default class Disclaimer extends React.Component{
    render(){
        return(<div className="disclaimer" dangerouslySetInnerHTML={{__html: this.props.disclaimer}}/>)
    }
}